/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-unused-vars */
import React, {
  useState, useRef, useEffect, useLayoutEffect, useMemo,
} from 'react';
import ActionButton from 'components/Common/ActionButton';
import SideBar from 'components/pages/Marketing/Assets/SideBar';
import FloatBullets from 'components/pages/Marketing/Assets/FloatBullets';
import LoginNavButtons from 'components/pages/Marketing/Assets/LoginNavButtons';
import Container from 'components/pages/Marketing/Assets/Container';
import { useHistory } from 'react-router-dom';
import StrictContainer from 'components/pages/Marketing/Assets/StrictContainer';
import {
  DataStudioDemo,
  offeringsBackground,
  GoogleColorfulLogo,
  facebookIconDark,
  folder,
  questions,
  GoogleGmail,
  GoogleNetwork,
  GoogleSearch,
  GoogleYouTube,
  OfferPayment,
  triangle,
  offerStepOne,
  offerStepTwo,
  offerStepThree,
  collaboration,
  shopeeLoge,
  HHGBrandLogo2,
  PhoneIcon2,
  MailIcon2,
  LINEicon2,
  HGGFullLogo,
  IGStories,
  IGNewsLine,
  FBNewsLine,
  FBMarketplace,
  newOfferBackground,
  FacebookIcon2,
  GoogleIcon2,
  PChomeIcon2,
  ShopeeIcon2,
} from 'assets/exports/imageExport';
import classNames from 'classnames';
import Styles from './index.module.css';

function MarketingOffer() {
  const history = useHistory();

  const levers = {
    Facebook: 'CPAS',
    Google: 'Real Shopper',
  };

  const tabs = {
    [levers.Google]: [
      { name: '搜尋', img: GoogleSearch },
      { name: '網站聯播網', img: GoogleNetwork },
      { name: 'Youtube', img: GoogleYouTube },
      { name: 'Gmail信箱', img: GoogleGmail },
    ],
    [levers.Facebook]: [
      { name: 'Facebook 動態消息', img: FBNewsLine },
      { name: 'Instagram 動態消息', img: IGNewsLine },
      { name: 'Facebook Marketplace', img: FBMarketplace },
      { name: 'Instagram 限時動態', img: IGStories },
    ],
  };

  const content = {
    [levers.Facebook]: 'Facebook & Instagram 全版位投放 社群版位，一次到位',
    [levers.Google]: 'SSC智慧型廣告 RS專屬廣告利器 攻佔GOOGLE所有版位',
  };

  const [activeLever, setActiveLever] = useState(levers.Facebook);
  const [activeTab, setActiveTab] = useState(0);

  // Anchors refs
  const sectionOneRef = useRef();
  const sectionTwoRef = useRef();
  const sectionThreeRef = useRef();
  const sectionFourRef = useRef();
  const sectionFiveRef = useRef();
  const sectionSixRef = useRef();
  const sectionSevenRef = useRef();
  const sectionEightRef = useRef();
  const sectionNineRef = useRef();

  const sections = [
    {
      headerRef: sectionOneRef,
      id: 'sectionOne',
    },
    {
      headerRef: sectionTwoRef,
      id: 'sectionTwo',
    },
    {
      headerRef: sectionThreeRef,
      id: 'sectionThree',
    },
    {
      headerRef: sectionFourRef,
      id: 'sectionFour',
    },
    {
      headerRef: sectionFiveRef,
      id: 'sectionFive',
    },
    {
      headerRef: sectionSixRef,
      id: 'sectionSix',
    },
    {
      headerRef: sectionSevenRef,
      id: 'sectionSeven',
    },
    {
      headerRef: sectionEightRef,
      id: 'sectionEight',
    },
    {
      headerRef: sectionNineRef,
      id: 'sectionNine',
    },
  ];

  return (
    <>
      <Container>

        <StrictContainer>
          <SideBar />
          <LoginNavButtons><FloatBullets sections={sections} /></LoginNavButtons>
        </StrictContainer>

        <StrictContainer className={Styles.strictContainer_mobile}>
          <h1 className={classNames(Styles.effectTitle, Styles.title, Styles.effectTitle_mobile)}>成效型廣告</h1>
        </StrictContainer>

        <section className={Styles.effect} ref={sectionOneRef} id="sectionOne">
          <img className={Styles.effectBackgroundImage} src={newOfferBackground} alt="" />
          <StrictContainer>
            <div className={Styles.effect_wrapped}>
              <div className={Styles.effectTitle_wrapped}>
                <div className={Styles.effectAir} />
                <h1 className={classNames(Styles.effectTitle, Styles.title)}>成效型廣告</h1>
              </div>
              <div className={Styles.effectContent_wrapped}>
                <h1 className={Styles.effectContentTitle}>為效益而生的新廣告型態</h1>
                <div className={Styles.effectCards}>
                  <div className={Styles.effectCard}>
                    <div className={Styles.effectCardImage_wrapped}>
                      <img className={Styles.effectCardImage} src={facebookIconDark} alt="Facebook icon" />
                    </div>
                    <h3 className={Styles.effectCardTitle}>CPAS</h3>
                  </div>
                  <div className={Styles.effectCard}>
                    <div className={Styles.effectCardImage_wrapped}>
                      <img className={Styles.effectCardImage} src={GoogleColorfulLogo} alt="Google icon" />
                    </div>
                    <h3 className={Styles.effectCardTitle}>Real shopper</h3>
                  </div>
                </div>
              </div>
            </div>
          </StrictContainer>
        </section>

        <section className={Styles.result} ref={sectionTwoRef} id="sectionTwo">
          <div className={Styles.resultBackground_wrapped}>
            <div className={Styles.resultBackground_left} />
            <div className={Styles.resultBackground_right} />
          </div>
          <StrictContainer style={{ marginBottom: '0px' }}>
            <div className={Styles.resultContainer}>
              <div className={Styles.resultQuestions}>
                <h1 className={classNames(Styles.resultQuestionsTitle, Styles.title)}>過去，你知道的太少</h1>
                <p className={classNames(Styles.resultQuestionsSubstitle)}>只關注CPC，卻不知道廣告實<br />際帶來的訂單和業績</p>
                <div className={Styles.resultQuestionsImage_wrapped}>
                  <img src={questions} alt="" className={Styles.resultQuestionsImage} />
                </div>
              </div>
              <div className={Styles.resultPresentation}>
                <h1 className={classNames(Styles.resultPresentationTitle, Styles.title)}>現在， 使用成效型廣告實際成效 <br /> 你看得見!</h1>
                <p className={classNames(Styles.resultPresentationSubstitle)}>全新的廣告成績單，給您更確實的廣告價值
                  <div className={Styles.resultPresentationListContainer}>
                    廣告成績單
                    <div className={Styles.resultPresentationList_wrapped}>
                      <ul className={Styles.resultPresentationList}>
                        <li>廣告轉換訂單數</li>
                        <li>廣告轉換業績</li>
                        <li>廣告轉換品項</li>
                      </ul>
                      <ul className={Styles.resultPresentationList}>
                        <li>廣告轉換率</li>
                        <li>ROAS投報率</li>
                      </ul>
                    </div>
                  </div>
                </p>
                <div className={Styles.resultPresentationImage_wrapped}>
                  <img src={folder} alt="" className={Styles.resultQuestionsImage} />
                </div>
              </div>
            </div>
          </StrictContainer>
        </section>

        <StrictContainer>
          <div className={Styles.media} ref={sectionThreeRef} id="sectionThree">
            <h1 className={classNames(Styles.mediaTitle, Styles.title)}>運用成效型廣告，你可以</h1>
            <div className={Styles.mediaContent_wrapped}>
              <div className={Styles.mediaContentImg_wrapped}>
                <img src={tabs[activeLever][activeTab].img} alt="" className={Styles.mediaContentImg} />
              </div>
              <div className={Styles.mediaContent}>
                <h3 className={Styles.mediaContentTitle}>搶佔線上陳列位，媒體版位鋪好撲滿</h3>
                <p className={Styles.mediaContentSubtitle}>成效型廣告全方位佈局<br />多元管道不放過任何一個版位</p>
                <div className={Styles.mediaContentLevers}>
                  {Object.keys(levers).map((lever) => (
                    <button
                      key={levers[lever]}
                      type="button"
                      className={classNames(
                        Styles.mediaContentLever,
                        { [Styles.mediaContentLever_active]: levers[lever] === activeLever },
                      )}
                      onClick={() => setActiveLever(levers[lever])}
                    >
                      <div className={Styles.mediaContentLeverIcon_wrapped}>
                        <img src={levers[lever] === 'CPAS' ? facebookIconDark : GoogleColorfulLogo} alt="" className={Styles.mediaContentLeverIcon} />
                      </div>
                      <span>{levers[lever]}</span>
                    </button>
                  ))}
                </div>
                <div className={classNames(Styles.mediaContentImg_wrapped, Styles.mediaContentImg_wrapped_mobile)}>
                  <img src={tabs[activeLever][activeTab].img} alt="" className={Styles.mediaContentImg} />
                </div>
                <p className={Styles.mediaContentText}>{content[activeLever]}</p>
                <div className={Styles.mediaContentTabs}>
                  {tabs[activeLever].map((btn, index) => (
                    <button
                      key={btn.name}
                      type="button"
                      className={classNames(
                        Styles.mediaContentTab,
                        { [Styles.mediaContentTab_active]: index === activeTab },
                      )}
                      onClick={() => setActiveTab(index)}
                    >
                      {btn.name.split(' ').length >= 2
                        ? btn.name.split(' ').map((word) => <><span>{word}</span><br /></>)
                        : btn.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.payment} ref={sectionFourRef} id="sectionFour">
            <div className={Styles.paymentImg_wrapped}>
              <img src={OfferPayment} alt="" className={Styles.paymentImg} />
            </div>
            <div className={Styles.paymentContent}>
              <h3 className={Styles.paymentContentTitle}>廣告投放更精準的消費者名單</h3>
              <p className={Styles.paymentContentText}>電商受重受眾名單X數位媒體廣告興趣受眾，鎖定真正有消費潛力的顧客</p>
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.rate} ref={sectionFiveRef} id="sectionFive">
            <div className={Styles.rateImg_wrapped}>
              <img src={triangle} alt="triangle" className={Styles.rateImg} />
            </div>
            <div className={Styles.rateContent_wrapped}>
              <div className={Styles.rateContent}>
                <h3 className={Styles.rateContentTitle}>揭開電商平台消費者</h3>
                <h3 className={Styles.rateContentTitle}>真實購買行為</h3>
                <div className={Styles.rateContentSeparator} />
                <p className={Styles.rateContentText}>廣告報酬率廣告投資方程式<br />讓您看到最真實的廣告成效</p>
              </div>
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.dataStudio} ref={sectionSixRef} id="sectionSix">
            <h1 className={classNames(Styles.dataStudioTitle, Styles.title)}>視覺化報表，輕鬆掌握成效</h1>
            <div className={Styles.dataStudioImg_wrapped}>
              <img src={DataStudioDemo} alt="" className={Styles.dataStudioImg} />
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.steps} ref={sectionSevenRef} id="sectionSeven">
            <h1 className={classNames(Styles.stepsTitle, Styles.title)}>運用成效型廣告，你可以</h1>
            <div className={Styles.stepsContainer}>
              <div className={Styles.stepsStep}>
                <p className={Styles.stepsStepIndex}>1</p>
                <p className={Styles.stepsStepText}>商品清單與廣告系統串接</p>
                <div className={Styles.stepsStepImg_wrapped}>
                  <img src={offerStepOne} alt="" className={Styles.stepsStepImg} />
                </div>
              </div>
              <div className={Styles.stepsStep}>
                <p className={Styles.stepsStepIndex}>2</p>
                <p className={Styles.stepsStepText}>成效型曝光給更精準客群導入<br />平台賣場購買</p>
                <div className={Styles.stepsStepImg_wrapped}>
                  <img src={offerStepTwo} alt="" className={Styles.stepsStepImg} />
                </div>
              </div>
              <div className={Styles.stepsStep}>
                <p className={Styles.stepsStepIndex}>3</p>
                <p className={Styles.stepsStepText}>轉換結果回傳廣告後台衡量<br />廣告成果</p>
                <div className={Styles.stepsStepImg_wrapped}>
                  <img src={offerStepThree} alt="" className={Styles.stepsStepImg} />
                </div>
              </div>
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.collaboration} ref={sectionEightRef} id="sectionEight">
            <div className={Styles.collaborationTitle_wrapped}>
              <h1 className={classNames(Styles.collaborationTitle, Styles.title)}>
                最佳代理商做您的最強神隊友
                <span className={Styles.collaborationTitleOverlay} />
              </h1>
            </div>
            <div className={Styles.collaboration__img_wrapped}>
              <img src={collaboration} alt="Collaboration illustration" className={Styles.collaboration__img} />
            </div>
            <div className={Styles.collaboration__cards}>
              <div className={Styles.collaboration__card}>
                <div className={Styles.collaboration__cardIcon_wrapped}>
                  <img src={FacebookIcon2} alt="Shopee logo" className={Styles.collaboration__cardIcon} />
                </div>
                <span className={Styles.collaboration__cardText}>認證廣告代理商</span>
              </div>
              <div className={Styles.collaboration__card}>
                <div className={Styles.collaboration__cardIcon_wrapped}>
                  <img src={GoogleIcon2} alt="Shopee logo" className={Styles.collaboration__cardIcon} />
                </div>
                <span className={Styles.collaboration__cardText}>成效行廣告合作夥伴</span>
              </div>
              <div className={Styles.collaboration__card}>
                <div className={Styles.collaboration__cardIcon_wrapped}>
                  <img src={ShopeeIcon2} alt="Shopee logo" className={Styles.collaboration__cardIcon} />
                </div>
                <span className={Styles.collaboration__cardText}>官方認證代理商</span>
              </div>
              <div className={Styles.collaboration__card}>
                <div className={Styles.collaboration__cardIcon_wrapped}>
                  <img src={PChomeIcon2} alt="Shopee logo" className={Styles.collaboration__cardIcon} />
                </div>
                <span className={Styles.collaboration__cardText}>成效行廣告合作夥伴</span>
              </div>
            </div>
          </div>
        </StrictContainer>

        <StrictContainer>
          <div className={Styles.prefooter} ref={sectionNineRef} id="sectionNine">
            <h1 className={classNames(Styles.prefooterTitle, Styles.title)}>現在就讓您的廣告投資變現</h1>
            <div className={Styles.prefooterButtons}>
              <ActionButton onClick={() => { history.push('/Calculator'); }} className={Styles.prefooterButton}>試算報酬</ActionButton>
              <ActionButton onClick={() => { history.push('/Register'); }} className={Styles.prefooterButton}>立即註冊</ActionButton>
            </div>
          </div>
        </StrictContainer>

        <footer className={Styles.footer}>
          <StrictContainer>
            <div className={Styles.footerContent}>
              <div className={Styles.footerLogo_wrapped}>
                <img src={HHGBrandLogo2} alt="Footer logo of Galaxy" />
              </div>
              <div className={Styles.footerIcon_wrapped}>
                <img src={PhoneIcon2} alt="Phone Icon" />
              </div>
              <a href="mailto:contactme@hhgalaxy.com.tw" className={Styles.footerIcon_wrapped}>
                <img src={MailIcon2} alt="Mail Icon" />
              </a>
              <a rel="noreferrer" target="_blank" href="https://liff.line.me/1645278921-kWRPP32q/?accountId=416ksyvl" className={Styles.footerIcon_wrapped}>
                <img src={LINEicon2} alt="Line Icon" />
              </a>
              <div className={Styles.footerLogo_wrapped_mobile}>
                <img src={HGGFullLogo} alt="Footer logo of Galaxy" />
              </div>
            </div>
          </StrictContainer>
        </footer>

      </Container>
    </>
  );
}

export default MarketingOffer;
